import happySnowflakeUrl from "@img/apology/happy-snowflake.png";
import excitedSnowflakeUrl from "@img/apology/excited-snowflake.png";
import confusedSnowflakeUrl from "@img/apology/confused-snowflake.png";
import sadSnowflakeUrl from "@img/apology/sad-snowflake.png";
import lostSnowflakeUrl from "@img/apology/lost-snowflake.png";

const alertTypeLookup = {
    happy: { imgUrl: happySnowflakeUrl, alt: "a cartoon happy snowflake", style: "info" },
    excited: { imgUrl: excitedSnowflakeUrl, alt: "a cartoon excited snowflake", style: "success" },
    confused: { imgUrl: confusedSnowflakeUrl, alt: "a cartoon confused snowflake", style: "warning" },
    sad: { imgUrl: sadSnowflakeUrl, alt: "a cartoon sad snowflake", style: "error" },
    lost: { imgUrl: lostSnowflakeUrl, alt: "a cartoon lost snowflake", style: "warning" },
    sucess: { style: "sucess" },
    info: { style: "info" },
    warning: { style: "warning" },
    error: { style: "error" },
};

const defaultImgSize = 45;

customElements.define(
    "nwcc-inline-alert",
    class extends HTMLElement {
        constructor() {
            super();
            const template = /*html*/ `
        <div role="alert">
            <button
                class="fsa-alert__close"
                data-behavior="alert-dismiss"
                type="button"
                title="Dismiss this message"
                aria-label="Dismiss this message"
            ></button>
            <div class="fsa-alert__body">
                <div class="fsa-level">
                    ${this.getImg()}
                    <h3 class="fsa-alert__heading">${this.getTitle()}</h3>
                </div>
                <p class="fsa-alert__text fsa-show@l">
                    ${this.getBody()}
                </p>
            </div>
        </div>`;

            this.innerHTML = template;
            this.setAlertClassName();
            this.addCloseButtonListener();
        }

        setAlertClassName() {
            const alertIconClass = alertTypeLookup[this.dataset.type]?.imgUrl ? " fsa-alert--no-icon" : "";
            const alertClassName = `fsa-alert fsa-alert--${this.getStyle()}${alertIconClass}`;
            this.querySelector('[role="alert"]').className = alertClassName;
        }

        getStyle() {
            return alertTypeLookup[this.dataset.type]?.style || "info";
        }

        getTitle() {
            return this.dataset.title || "";
        }

        setTitle(title) {
            const titleElement = this.querySelector(".fsa-alert__heading");
            return (titleElement.innerHTML = title);
        }

        setType(type, imgSize) {
            this.dataset.type = type;
            this.dataset.imgSize = Number(imgSize) || defaultImgSize;
            const imgHTML = this.getImg();
            const bodyElement = this.querySelector(".fsa-alert__body");
            bodyElement.insertAdjacentHTML("beforebegin", imgHTML);
            this.setAlertClassName();
        }

        getImg() {
            const imgSize = Number(this.dataset.imgSize) || defaultImgSize;
            const snowflake = this.getSnowflake();
            if (imgSize && snowflake.imgUrl && snowflake.alt) {
                return /*html*/ `
          <img
              class="fsa-level__item--align-middle"
              src=${snowflake.imgUrl}
              alt="${snowflake.alt}"
              width="${imgSize}"
              height="${imgSize}"
          >`;
            }
            return "";
        }

        getSnowflake() {
            return Object.keys(alertTypeLookup).includes(this.dataset.type) ? alertTypeLookup[this.dataset.type] : {};
        }

        getBody() {
            return this.dataset.body || "";
        }

        setBody(html) {
            const titleElement = this.querySelector(".fsa-alert__text");
            return (titleElement.innerHTML = html);
        }

        addCloseButtonListener() {
            const alertDismissElement = this.querySelector('[data-behavior~="alert-dismiss"]');
            const alert = alertDismissElement.closest(".fsa-alert");
            alertDismissElement.addEventListener("click", () => {
                alert.style.opacity = 0;
                alert.remove();
            });
        }
    },
);
